import type { JSX } from 'react'
import type { ILabelProps } from 'atoms/Label'
import type { ILabelGroupProps } from '../LabelGroup'

import { Fonts } from 'atoms/Label/Label.h'
import { LabelSecondaryRoundedTemplate } from 'atoms/Label/Templates'
import { LabelGroup } from '../LabelGroup'

export interface ILabelGroupTemplate2Props extends Omit<
  ILabelGroupProps,
  'children'
> {
  list: ILabelProps['title'][]
  font?: Fonts
}

export const LabelGroupTemplate2 = ({
  list = [],
  font = Fonts.Caption4,
  ...rest
}: ILabelGroupTemplate2Props): JSX.Element => {
  const labels = list.filter((item) => item)

  return labels?.length > 0 ? (
    <LabelGroup {...rest}>
      {labels.map((title, i) => (
        <LabelSecondaryRoundedTemplate
          key={`${i}${title}`}
          title={title}
          font={font}
        />
      ))}
    </LabelGroup>
  ) : (
    <></>
  )
}
